<template>
    <div>
        <div class="top">
            <div class="topleft">
                <el-breadcrumb separator="/">
                    <el-breadcrumb-item v-if="this.userInfo.user.roles[0].id == 1" :to="{ path: '/home' }">{{$t('home')}}</el-breadcrumb-item>
                    <el-breadcrumb-item>{{$t('collectionManagement')}}</el-breadcrumb-item>
                    <el-breadcrumb-item>{{$t('call0')}}</el-breadcrumb-item>
                </el-breadcrumb>
            </div>
        </div>
        <div class="cont">
            <div class="listbox">
                <div class="listright" v-loading="loading">
                    <div style="width: 96%; margin-left:2%; height:368px; margin-top: 5px;">
                        <div>
                            <table style="width: 100%; margin-top: 10px; line-height: 30px;" border="1">
                                <tr style="font-weight: bolder;">
                                    <td>D_1 {{$t('call1')}}</td>
                                    <td>D0 {{$t('call1')}}</td>
                                    <td>D1 {{$t('call1')}}</td>
                                    <td>D2 {{$t('call1')}}</td>
                                    <td>D3 {{$t('call1')}}</td>
                                    <td>D4 {{$t('call1')}}</td>
                                    <td>D5 {{$t('call1')}}</td>
                                    <td>D6 {{$t('call1')}}</td>
                                    <td>D7 {{$t('call1')}}</td>
                                </tr>
                                <tr style="font-weight: bolder;">
                                    <td>{{$t('call2')}} {{total.data_1}}</td>
                                    <td>{{$t('call2')}} {{total.data0}}</td>
                                    <td>{{$t('call2')}} {{total.data1}}</td>
                                    <td>{{$t('call2')}} {{total.data2}}</td>
                                    <td>{{$t('call2')}} {{total.data3}}</td>
                                    <td>{{$t('call2')}} {{total.data4}}</td>
                                    <td>{{$t('call2')}} {{total.data5}}</td>
                                    <td>{{$t('call2')}} {{total.data6}}</td>
                                    <td>{{$t('call2')}} {{total.data7}}</td>
                                </tr>
                                <tr style="font-weight: bolder;">
                                    <td>{{$t('call3')}}</td>
                                    <td>{{$t('call3')}}</td>
                                    <td>{{$t('call3')}}</td>
                                    <td>{{$t('call3')}}</td>
                                    <td>{{$t('call3')}}</td>
                                    <td>{{$t('call3')}}</td>
                                    <td>{{$t('call3')}}</td>
                                    <td>{{$t('call3')}}</td>
                                    <td>{{$t('call3')}}</td>
                                </tr>
                                <tr>
                                    <td>{{$t('call4')}} {{total.dayCall_1}}</td>
                                    <td>{{$t('call4')}} {{total.dayCall0}}</td>
                                    <td>{{$t('call4')}} {{total.dayCall1}}</td>
                                    <td>{{$t('call4')}} {{total.dayCall2}}</td>
                                    <td>{{$t('call4')}} {{total.dayCall3}}</td>
                                    <td>{{$t('call4')}} {{total.dayCall4}}</td>
                                    <td>{{$t('call4')}} {{total.dayCall5}}</td>
                                    <td>{{$t('call4')}} {{total.dayCall6}}</td>
                                    <td>{{$t('call4')}} {{total.dayCall7}}</td>
                                </tr>
                                <tr>
                                    <td>{{$t('call5')}} {{total.newCall_1}}</td>
                                    <td>{{$t('call5')}} {{total.newCall0}}</td>
                                    <td>{{$t('call5')}} {{total.newCall1}}</td>
                                    <td>{{$t('call5')}} {{total.newCall2}}</td>
                                    <td>{{$t('call5')}} {{total.newCall3}}</td>
                                    <td>{{$t('call5')}} {{total.newCall4}}</td>
                                    <td>{{$t('call5')}} {{total.newCall5}}</td>
                                    <td>{{$t('call5')}} {{total.newCall6}}</td>
                                    <td>{{$t('call5')}} {{total.newCall7}}</td>
                                </tr>
                                <tr>
                                    <td>{{$t('call6')}} {{total.oldCall_1}}</td>
                                    <td>{{$t('call6')}} {{total.oldCall0}}</td>
                                    <td>{{$t('call6')}} {{total.oldCall1}}</td>
                                    <td>{{$t('call6')}} {{total.oldCall2}}</td>
                                    <td>{{$t('call6')}} {{total.oldCall3}}</td>
                                    <td>{{$t('call6')}} {{total.oldCall4}}</td>
                                    <td>{{$t('call6')}} {{total.oldCall5}}</td>
                                    <td>{{$t('call6')}} {{total.oldCall6}}</td>
                                    <td>{{$t('call6')}} {{total.oldCall7}}</td>
                                </tr>
                                <tr>
                                    <td>{{$t('call7')}} {{total.newRecall_1}}</td>
                                    <td>{{$t('call7')}} {{total.newRecall0}}</td>
                                    <td>{{$t('call7')}} {{total.newRecall1}}</td>
                                    <td>{{$t('call7')}} {{total.newRecall2}}</td>
                                    <td>{{$t('call7')}} {{total.newRecall3}}</td>
                                    <td>{{$t('call7')}} {{total.newRecall4}}</td>
                                    <td>{{$t('call7')}} {{total.newRecall5}}</td>
                                    <td>{{$t('call7')}} {{total.newRecall6}}</td>
                                    <td>{{$t('call7')}} {{total.newRecall7}}</td>
                                </tr>
                                <tr>
                                    <td>{{$t('call8')}} {{total.oldRecall_1}}</td>
                                    <td>{{$t('call8')}} {{total.oldRecall0}}</td>
                                    <td>{{$t('call8')}} {{total.oldRecall1}}</td>
                                    <td>{{$t('call8')}} {{total.oldRecall2}}</td>
                                    <td>{{$t('call8')}} {{total.oldRecall3}}</td>
                                    <td>{{$t('call8')}} {{total.oldRecall4}}</td>
                                    <td>{{$t('call8')}} {{total.oldRecall5}}</td>
                                    <td>{{$t('call8')}} {{total.oldRecall6}}</td>
                                    <td>{{$t('call8')}} {{total.oldRecall7}}</td>
                                </tr>
                                <tr>
                                    <td>{{$t('call9')}} {{total.newRate_1}}</td>
                                    <td>{{$t('call9')}} {{total.newRate0}}</td>
                                    <td>{{$t('call9')}} {{total.newRate1}}</td>
                                    <td>{{$t('call9')}} {{total.newRate2}}</td>
                                    <td>{{$t('call9')}} {{total.newRate3}}</td>
                                    <td>{{$t('call9')}} {{total.newRate4}}</td>
                                    <td>{{$t('call9')}} {{total.newRate5}}</td>
                                    <td>{{$t('call9')}} {{total.newRate6}}</td>
                                    <td>{{$t('call9')}} {{total.newRate7}}</td>
                                </tr>
                                <tr>
                                    <td>{{$t('call10')}} {{total.oldRate_1}}</td>
                                    <td>{{$t('call10')}} {{total.oldRate0}}</td>
                                    <td>{{$t('call10')}} {{total.oldRate1}}</td>
                                    <td>{{$t('call10')}} {{total.oldRate2}}</td>
                                    <td>{{$t('call10')}} {{total.oldRate3}}</td>
                                    <td>{{$t('call10')}} {{total.oldRate4}}</td>
                                    <td>{{$t('call10')}} {{total.oldRate5}}</td>
                                    <td>{{$t('call10')}} {{total.oldRate6}}</td>
                                    <td>{{$t('call10')}} {{total.oldRate7}}</td>
                                </tr>
                                <tr>
                                    <td>{{$t('call11')}} {{total.rate_1}}</td>
                                    <td>{{$t('call11')}} {{total.rate0}}</td>
                                    <td>{{$t('call11')}} {{total.rate1}}</td>
                                    <td>{{$t('call11')}} {{total.rate2}}</td>
                                    <td>{{$t('call11')}} {{total.rate3}}</td>
                                    <td>{{$t('call11')}} {{total.rate4}}</td>
                                    <td>{{$t('call11')}} {{total.rate5}}</td>
                                    <td>{{$t('call11')}} {{total.rate6}}</td>
                                    <td>{{$t('call11')}} {{total.rate7}}</td>
                                </tr>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import apiurl from "@/api/public"
    import _api from "@/api/index"
    import Treeselect from '@riophae/vue-treeselect'
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    export default {
        components: {
            Treeselect
        },
        data() {
            return {
                loading:false,
                total:{
                    data_1: 0,
                    data0: 0,
                    data1: 0,
                    data2: 0,
                    data3: 0,
                    data4: 0,
                    data5: 0,
                    data6: 0,
                    data7: 0,

                    dayCall_1: 0,
                    dayCall0: 0,
                    dayCall1: 0,
                    dayCall2: 0,
                    dayCall3: 0,
                    dayCall4: 0,
                    dayCall5: 0,
                    dayCall6: 0,
                    dayCall7: 0,

                    newCall_1: 0,
                    newCall0: 0,
                    newCall1: 0,
                    newCall2: 0,
                    newCall3: 0,
                    newCall4: 0,
                    newCall5: 0,
                    newCall6: 0,
                    newCall7: 0,

                    oldCall_1: 0,
                    oldCall0: 0,
                    oldCall1: 0,
                    oldCall2: 0,
                    oldCall3: 0,
                    oldCall4: 0,
                    oldCall5: 0,
                    oldCall6: 0,
                    oldCall7: 0,

                    newRecall_1: 0,
                    newRecall0: 0,
                    newRecall1: 0,
                    newRecall2: 0,
                    newRecall3: 0,
                    newRecall4: 0,
                    newRecall5: 0,
                    newRecall6: 0,
                    newRecall7: 0,

                    oldRecall_1: 0,
                    oldRecall0: 0,
                    oldRecall1: 0,
                    oldRecall2: 0,
                    oldRecall3: 0,
                    oldRecall4: 0,
                    oldRecall5: 0,
                    oldRecall6: 0,
                    oldRecall7: 0,

                    newRate_1: 0,
                    newRate0: 0,
                    newRate1: 0,
                    newRate2: 0,
                    newRate3: 0,
                    newRate4: 0,
                    newRate5: 0,
                    newRate6: 0,
                    newRate7: 0,

                    oldRate_1: 0,
                    oldRate0: 0,
                    oldRate1: 0,
                    oldRate2: 0,
                    oldRate3: 0,
                    oldRate4: 0,
                    oldRate5: 0,
                    oldRate6: 0,
                    oldRate7: 0,

                    rate_1: 0,
                    rate0: 0,
                    rate1: 0,
                    rate2: 0,
                    rate3: 0,
                    rate4: 0,
                    rate5: 0,
                    rate6: 0,
                    rate7: 0,
                },
            }
        },
        created() {
            this.userInfo=JSON.parse(localStorage.getItem("userinfo"))
            this.getList()
        },
        methods: {
            getList() {
                this.loading = true
                _api.get(apiurl.callreport, {
                    nation:localStorage.getItem("nation"),
                }).then(res => {
                    this.loading = false
                    this.total.data_1=res.data.data_1
                    this.total.data0=res.data.data0
                    this.total.data1=res.data.data1
                    this.total.data2=res.data.data2
                    this.total.data3=res.data.data3
                    this.total.data4=res.data.data4
                    this.total.data5=res.data.data5
                    this.total.data6=res.data.data6
                    this.total.data7=res.data.data7

                    this.total.dayCall_1=res.data.dayCall_1
                    this.total.dayCall0=res.data.dayCall0
                    this.total.dayCall1=res.data.dayCall1
                    this.total.dayCall2=res.data.dayCall2
                    this.total.dayCall3=res.data.dayCall3
                    this.total.dayCall4=res.data.dayCall4
                    this.total.dayCall5=res.data.dayCall5
                    this.total.dayCall6=res.data.dayCall6
                    this.total.dayCall7=res.data.dayCall7

                    this.total.newCall_1=res.data.newCall_1
                    this.total.newCall0=res.data.newCall0
                    this.total.newCall1=res.data.newCall1
                    this.total.newCall2=res.data.newCall2
                    this.total.newCall3=res.data.newCall3
                    this.total.newCall4=res.data.newCall4
                    this.total.newCall5=res.data.newCall5
                    this.total.newCall6=res.data.newCall6
                    this.total.newCall7=res.data.newCall7

                    this.total.oldCall_1=res.data.oldCall_1
                    this.total.oldCall0=res.data.oldCall0
                    this.total.oldCall1=res.data.oldCall1
                    this.total.oldCall2=res.data.oldCall2
                    this.total.oldCall3=res.data.oldCall3
                    this.total.oldCall4=res.data.oldCall4
                    this.total.oldCall5=res.data.oldCall5
                    this.total.oldCall6=res.data.oldCall6
                    this.total.oldCall7=res.data.oldCall7

                    this.total.newRecall_1=res.data.newRecall_1
                    this.total.newRecall0=res.data.newRecall0
                    this.total.newRecall1=res.data.newRecall1
                    this.total.newRecall2=res.data.newRecall2
                    this.total.newRecall3=res.data.newRecall3
                    this.total.newRecall4=res.data.newRecall4
                    this.total.newRecall5=res.data.newRecall5
                    this.total.newRecall6=res.data.newRecall6
                    this.total.newRecall7=res.data.newRecall7

                    this.total.oldRecall_1=res.data.oldRecall_1
                    this.total.oldRecall0=res.data.oldRecall0
                    this.total.oldRecall1=res.data.oldRecall1
                    this.total.oldRecall2=res.data.oldRecall2
                    this.total.oldRecall3=res.data.oldRecall3
                    this.total.oldRecall4=res.data.oldRecall4
                    this.total.oldRecall5=res.data.oldRecall5
                    this.total.oldRecall6=res.data.oldRecall6
                    this.total.oldRecall7=res.data.oldRecall7

                    this.total.newRate_1=res.data.newRate_1
                    this.total.newRate0=res.data.newRate0
                    this.total.newRate1=res.data.newRate1
                    this.total.newRate2=res.data.newRate2
                    this.total.newRate3=res.data.newRate3
                    this.total.newRate4=res.data.newRate4
                    this.total.newRate5=res.data.newRate5
                    this.total.newRate6=res.data.newRate6
                    this.total.newRate7=res.data.newRate7

                    this.total.oldRate_1=res.data.oldRate_1
                    this.total.oldRate0=res.data.oldRate0
                    this.total.oldRate1=res.data.oldRate1
                    this.total.oldRate2=res.data.oldRate2
                    this.total.oldRate3=res.data.oldRate3
                    this.total.oldRate4=res.data.oldRate4
                    this.total.oldRate5=res.data.oldRate5
                    this.total.oldRate6=res.data.oldRate6
                    this.total.oldRate7=res.data.oldRate7

                    this.total.rate_1=res.data.rate_1
                    this.total.rate0=res.data.rate0
                    this.total.rate1=res.data.rate1
                    this.total.rate2=res.data.rate2
                    this.total.rate3=res.data.rate3
                    this.total.rate4=res.data.rate4
                    this.total.rate5=res.data.rate5
                    this.total.rate6=res.data.rate6
                    this.total.rate7=res.data.rate7
                })
            },
        }
    }
</script>
<style scoped>
    .lefttop {
        padding: 8px;
    }

    .listbox {
        display: flex;
    }

    .listleft {
        width: 20%;
        border: 1px solid #EBEEF5;
    }

    .listright {
        width: 100%;
        margin-left: 1%;
    }

    .top {
        margin-top: 15px;
    }

    .listrighttop {
        padding: 0 10px;
        background: rgb(245, 245, 245);
        height: 40px;
        overflow: hidden;
        line-height: 40px;
        border-bottom: 1px solid #EBEEF5;
    }

    .listrighttop strong {
        float: left;
    }

    .listrighttop span {
        float: right;
    }

    ::v-deep .vue-treeselect__control,
    ::v-deep .vue-treeselect__placeholder,
    ::v-deep .vue-treeselect__single-value {
        height: 30px;
        line-height: 30px;
    }
</style>